import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthProvider';
export function ProtectedRoute({ children }) {
    const { session, isPending } = useAuth();
    if (isPending) {
        return _jsx("div", { style: { textAlign: 'center', padding: '2rem', color: '#808090' }, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." });
    }
    if (!session) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
